import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<span enTooltip title="{{ data[key] }}">{{ data[key] }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataOnlyComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  ngOnInit(): void {
    super.ngOnInit();
  }
}
